module.exports = __webpack_public_path__ + "img/logo_branca.c1d70052.png";